export default __webpack_public_path__ + "img/1c519e16f845e788da8ddbada1d655e6.png";